import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import AddLeadPopup from './components/AddLeadPopup';
import axios from 'axios';
import AddBulkLeadPopup from './components/AddBulkLeadPopup';

const AttendanceList = () => {
    const [toggleLeadPopup, setToggleLeadPopup] = useState(0);
    const [toggleBulkLeadPopup, setToggleBulkLeadPopup] = useState(0);
    const [userDetails, setUserDetails] = useState([]);
    const [filterStatus, setfilterStatus] = useState("");

    const [clientData, setClientData] = useState([]);

    const url = window.url;
    const qry = new FormData();
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem("user")) {
            const userData = JSON.parse(localStorage.getItem("user"));
            setUserDetails(userData);
            // console.log(userData);

            if (userData.designation == "B" || userData.designation == "A" || userData.designation == "C" || userData.designation == "D") {

            }
            else {
                navigate("/");
            }

            qry.append("emp_id", userData.user_id);

        }
        fetchMyLeadsApi();
    }, []);

    const reload = () => {
        qry.append("emp_id", userDetails.user_id);
        fetchMyLeadsApi();
    }
    const fetchMyLeadsApi = () => {
        axios.post(url + "fetch-attendance.php", qry).then((response) => {
            if (response.data.status == 1) {
                setClientData(response.data.data);
                console.log(response.data.data);
            }
            // console.log(response.data);
        }).catch(error => {
            console.log("error");
        });
    }




    const closeLeadPopup = () => {
        setToggleLeadPopup(0);
    }
    const closeBulkLeadPopup = () => {
        setToggleBulkLeadPopup(0);
    }

    var i = 0;
    const index = () => {
        i = i + 1;
    }

    return (
        <>

            {toggleLeadPopup === 1 ?
                <AddLeadPopup reload={reload} close={closeLeadPopup} />
                : <></>
            }
            {toggleBulkLeadPopup === 1 ?
                <AddBulkLeadPopup reload={reload} close={closeBulkLeadPopup} />
                : <></>
            }

            <Header />

            <div className='container-head'>
                <div>
                    <h2> My Leads</h2>

                    <div className='filter'>

                        <select onChange={(e) => setfilterStatus(e.target.value)}>
                            <option value="1"> Filter Status</option>
                            <option value="1"> Dipesh </option>
                            <option value="4"> Banas </option>
                            <option value="5"> Pankaj </option>
                            <option value="6"> Manisha </option>
                            <option value="7"> Chirag </option>
                            <option value="8"> Mahesh </option>
                            <option value="9"> Lovish </option>

                        </select>
                    </div>

                </div>
                <div>
                    {userDetails.designation == "B" || userDetails.designation == "A" ? <button className='crm-btn-primary' style={{ "margin": "0 10px 0 10px" }} onClick={() => { setToggleBulkLeadPopup(1) }}> <span className='crm-dm-hide'> Add Bulk </span> <i className='fa fa-users'></i> </button> : <></>}

                    <button className='crm-btn-primary' onClick={() => { setToggleLeadPopup(1) }}> <span className='crm-dm-hide'> Add New </span> <i className='fa fa-user-plus'></i> </button>
                </div>
            </div>

            <div className='crm-container'>
                <div className='crm-table visible-hide'>

                    <table>
                        <thead>
                            <tr> <th> S No</th> <th> Date </th> <th> Entry </th> <th> Exit </th> <th>Hour</th> </tr>
                        </thead>

                        {
                            clientData.length != 0 ?
                                <>
                                    {filterStatus != "" ?
                                        clientData[filterStatus].data.map((data) => {
                                            index();
                                            return (
                                                <tr className={data.working_hours == "Absent" && data.Holiday == "No" ? "crm-bg-light-red" : data.event == "Week Off" ? "crm-bg-light-green" : (data.event != "Week Off" && data.event != "Working Day") ? "crm-bg-light-pink" : ""}>
                                                    <td> {i}</td>
                                                    <td>{data.date + " (" + data.day + ")"}</td>
                                                    <td className={data.entry == "no" ? "crm-bg-red crm-color-white" : ""}>{data.entry == 0 ? data.day : data.entry == "no" ? "No Thumb impression" : data.entry}</td>
                                                    <td className={data.exit == "no" ? "crm-bg-red crm-color-white" : ""}> {data.exit == 0 ? data.event : data.exit == "no" ? "No Thumb impression" : data.exit} </td>
                                                    <td>{data.Holiday == "Yes" ? "Holiday" : data.working_hours}</td>
                                                </tr>
                                            );
                                        })
                                        : <></>
                                    }
                                </>
                                : <><tr><td>Empty</td></tr></>
                        }
                    </table>
                </div>


            </div>
        </>
    )
}

export default AttendanceList;